import { Button, Form, Input, Table } from "antd";
import { IoTrashBinOutline } from "react-icons/io5";
import { FiEdit } from "react-icons/fi";
import Manage from "..";
import {  useEffect, useState } from "react";
import UpdateUser from "./components/UpdateUser";
import DeleteUser from "./components/DeleteUser";
import CreateWrapper from "./components/CreateWrapper";
import { RiFilterOffLine, RiLockPasswordLine } from "react-icons/ri";
import UpdatePass from "./components/UpdatePass";
import fetchDataTrace from "../../../services/fetchDataTrace";
import UpdateStatus from "./components/UpdateStatus";
import { ColumnsType } from "antd/lib/table";
import { ExportToExcel } from "../../../utils/XLSXExport";
import { BiExport } from "react-icons/bi";
import UpdateSign from "./components/UpdateSign";
import { FaSignature } from "react-icons/fa";
import { useQuery } from "@tanstack/react-query";
import { handleFetchUsers } from "../../../api/users";
const { Search } = Input;

export default function AllUsers() {
  const [updateModal, setUpdateModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [passModal, setPassModal] = useState(false);
  const [signModal, setSignModal] = useState(false);
  const [statusModal, setStatusModal] = useState(false);
  const [selected, setSelected] = useState({});
  const [exporting, setExporting] = useState(false);
  const [form] = Form.useForm();

  const initials = {
    name: "",
  };

  const [filters, setFilters] = useState<any>({ ...initials });

  const params = `name=${filters?.name}`;

  const [pagination, setPagination] = useState<any>({
    page: 1,
    limit: 10,
    total: 0,
  });

  const {
    data: users,
    refetch,
    isLoading,
  } = useQuery({
    queryKey: ["users", pagination.page, pagination.limit, params],
    queryFn: () =>
      handleFetchUsers({
        page: pagination.page,
        limit: pagination.limit,
        params,
      }),
  });

  const handlePageChange = (e: any) => {
    setPagination((prev: any) => ({
      ...prev,
      page: e.current,
      limit: e.pageSize,
    }));
  };

  const clearAllFilters = async () => {
    form.resetFields();
    setFilters({ ...initials });
    handleRefetch();
  };
  const handleRefetch = () => {
    refetch();
  };

  const handleExportUsers = async () => {
    setExporting(true);
    const uri = "users";
    const response = await fetchDataTrace({ uri: uri });
    setExporting(false);
    return response?.payload;
  };


  interface DataType {
    key: React.Key;
    name: string;
    age: number;
    address: string;
  }

  const columns: ColumnsType<DataType> = [
    {
      title: "S/N",
      width: 50,
      render: (record: any, text: any, index: any) => (
        <span className="text-gray-700 ml-2">
        {pagination?.page * pagination?.limit -
          pagination?.limit +
          index +
          1}
      </span>
      ),
      fixed: "left",
    },
    {
      title: "KJL ID",
      width: 100,
      render: (record: any) => (
        <div className="text-gray-700">{record?.kjlID || "-"}</div>
      ),
      fixed: "left",
    },
    {
      title: "Name",
      width: 250,
      render: (record: any) => (
        <div className="text-gray-700 truncate">
          {record?.firstname === null
            ? "-"
            : `${record?.firstname} ${record?.lastname}`}
        </div>
      ),

    },
    {
      title: "Email",
      width: 250,
      render: (record: any) => (
        <div className="text-gray-700">
          {record?.email === null ? "-" : `${record?.email}`}
        </div>
      ),
    },

    {
      title: "Mobile 1",
      width: 150,
      render: (record: any) => (
        <div className="text-gray-700">
          {record?.mobile === null ? "-" : `${record?.mobile}`}
        </div>
      ),
    },
    {
      title: "Mobile 2",
      width: 150,
      render: (record: any) => (
        <div className="text-gray-700">
          {record?.mobile2 === undefined ? "-" : `${record?.mobile2}`}
        </div>
      ),
    },
    {
      title: "Role",
      width: 150,
      render: (record: any) => (
        <div className="text-gray-700 truncate">
          {record?.role === null ? "-" : record?.role?.name}
        </div>
      ),
    },
    {
      title: "Company",
      width: 230,
      render: (record: any) => (
        <div className="text-gray-700 truncate">
          {record?.firm?.name === undefined
            ? "TTL 3rd Part Dealer"
            : record?.firm?.name}
        </div>
      ),
    },
    {
      title: "Office",
      width: 160,
      render: (record: any) => (
        <div className="text-gray-700">
          {record?.site === null ? "-" : record?.site?.name}
        </div>
      ),
    },

    {
      title: "Access Level",
      width: 110,
      render: (record: any) => (
        <div className="text-gray-700">
          {record?.accessLevel === null ? "-" : record?.accessLevel}
        </div>
      ),
    },
    {
      title: "Booking SMS",
      width: 110,
      render: (record: any) => (
        <div className="text-gray-700">{record?.isMessaged ? "Yes" : "No"}</div>
      ),
    },

    {
      title: "Upload Rights",
      width: 140,
      render: (record: any) => (
        <div className="text-gray-700">{record?.canUpload ? "Yes" : "No"}</div>
      ),
    },

    {
      title: "Claim Privilege",
      width: 140,
      render: (record: any) => (
        <div className="text-gray-700">{record?.isClaimer ? "Yes" : "No"}</div>
      ),
    },

    {
      title: "Roadside Access",
      width: 140,
      render: (record: any) => (
        <div className="text-gray-700">{record?.isRoadside ? "Yes" : "No"}</div>
      ),
    },
    {
      title: "Signature",
      width: 150,
      render: (record: any) => (
        <div className="">
          {record?.signature && (
            <div className="border p-1">
              <img src={record?.signature} />
            </div>
          )}
        </div>
      ),
    },
    {
      title: "Status",
      width: 120,
      render: (record: any) => (
        <div className="flex">
          <button
            onClick={() => {
              setSelected({
                ...record,
              });
              setStatusModal(true);
            }}
            className="flex justify-center items-center border text-gray-700 rounded-md p-2 hover:bg-gray-200 cursor-pointer"
          >
            {record?.isActive ? (
              <div className="flex items-center justify-center text-green-600">
                <FiEdit />
                <span className="ml-1">Active</span>
              </div>
            ) : (
              <div className="flex items-center justify-center text-red-600">
                <FiEdit />
                <span className="ml-1">Inactive</span>
              </div>
            )}
          </button>
        </div>
      ),
    },

    {
      title: "Action",
      width: 160,
      fixed: "right",
      render: (record: any) => (
        <div className="flex">


          <button
            onClick={() => {
              setSelected({
                ...record,
              });
              setSignModal(true);
            }}
            className="flex justify-center items-center text-gray-700 mx-1 border rounded-md p-2 bg-gray-100 hover:bg-gray-200 cursor-pointer"
          >
            <FaSignature />
          </button>
          <button
            onClick={() => {
              setSelected({
                ...record,
              });
              setUpdateModal(true);
            }}
            className="flex justify-center items-center text-gray-700 border rounded-md p-2 bg-gray-100 hover:bg-gray-200 cursor-pointer"
          >
            <FiEdit />
          </button>
          <button
            onClick={() => {
              setSelected({
                ...record,
              });
              setPassModal(true);
            }}
            className="flex justify-center items-center ml-1 text-gray-700 border rounded-md p-2 bg-yellow-100 hover:bg-yellow-200 cursor-pointer"
          >
            <RiLockPasswordLine />
          </button>
          <button
            onClick={() => {
              setSelected({
                ...record,
              });
              setDeleteModal(true);
            }}
            className="flex justify-center items-center ml-1 text-gray-700 border rounded-md p-2 bg-red-100 hover:bg-red-200 cursor-pointer"
          >
            <IoTrashBinOutline />
          </button>
        </div>
      ),
    },
  ];


  useEffect(() => {
    setPagination({ ...pagination, total: users?.total });
  }, [users]);

  return (
    <Manage
      title={"Users"}
      subtitle={"All"}
      description={"List of all users"}
      actions={
        <div className="flex justify-end">
          <div className="flex">
              <Form layout="inline" form={form}>
                <Form.Item name="name">
                  <Search
                    placeholder="Search by name"
                    className="rounded-none"
                    allowClear
                    onSearch={(e: any) => {
                      setFilters({ ...filters, name: e });
                    }}
                  />
                </Form.Item>
              </Form>
              <Button
                className="mr-2 -ml-4 focus:outline-none hover:bg-red-100 rounded-none"
                onClick={() => {
                  clearAllFilters();
                }}
              >
                <RiFilterOffLine color="gray" />
              </Button>
            </div>
          <button
            color="#E50000"
            className="flex justify-center items-center border p-1 hover:bg-green-100 mr-2"
          >
            <BiExport size={24} />
            <span
              className="ml-2"
              onClick={async () => {
                setExporting(true)
                const users: any = await handleExportUsers();
                ExportToExcel(
                  users?.map((record: any, index: number) => {
                    return {
                      "S/N": index + 1,
                      "Full Name": `${record?.firstname} ${record?.lastname}`,

                      Email: record?.email ? record?.email : "-",
                      "Mobile 1": record?.mobile ? record?.mobile : "-",
                      "Mobile 2": record?.mobile2 ? record?.mobile2 : "-",
                      Company: record?.firm ? record?.firm?.name : "-",
                      Active: record?.isActive ? "Yes" : "No",
                    };
                  }),
                  "Users.xlsx"
                );
                setExporting(false)
              }}
            >
              {exporting ? "Exporting .... " : "Export To Excel"}
            </span>
          </button>
          <CreateWrapper refetch={handleFetchUsers} />
        </div>
      }
    >
      <div className="grid gap-x-0 grid-cols-12">
        <div className="col-span-12 sm:col-span-12 md:col-span-12">
          <Table
            size="small"
            dataSource={users?.records}
            columns={columns}
            scroll={{ y: 660, x: 0 }}
            rowKey="id"
            style={{ fontSize: "12px" }}
            bordered
            pagination={{
              current: pagination?.page,
              pageSize: pagination?.limit,
              total: pagination?.total,
            }}
            onChange={(e: any) => handlePageChange(e)}
            loading={isLoading}
          />

          <UpdateUser
            selected={selected}
            isVisible={updateModal}
            setUpdateModal={setUpdateModal}
            handleFetchUsers={handleFetchUsers}
          />

          <UpdatePass
            selected={selected}
            isVisible={passModal}
            setPassModal={setPassModal}
            handleFetchUsers={handleFetchUsers}
          />

          <UpdateSign
            selected={selected}
            isVisible={signModal}
            setVisible={setSignModal}
            refetch={handleFetchUsers}
          />

          <DeleteUser
            selected={selected}
            isVisible={deleteModal}
            setVisible={setDeleteModal}
            refetch={handleFetchUsers}
          />
          <UpdateStatus
            selected={selected}
            isVisible={statusModal}
            setVisible={setStatusModal}
            refetch={handleFetchUsers}
          />
        </div>
      </div>
    </Manage>
  );
}
